/**
 * 主题切换组件
 * 支持多种风格主题切换（科技/玻璃/新拟态/浅色）
 */
import React from 'react';
import { Dropdown, Button, Tooltip, Space } from 'antd';
import { BgColorsOutlined, CheckOutlined, ThunderboltFilled, ExperimentFilled, BlockOutlined, SunOutlined, SettingOutlined } from '@ant-design/icons';
import { useTheme, ThemeType } from '../../providers/ThemeAdaptorProvider';
import './ThemeSwitch.css';

const ThemeSwitch: React.FC = () => {
  const { currentTheme, setTheme, isAutoMode, setAutoMode } = useTheme();

  const themes: { key: ThemeType; label: string; icon: React.ReactNode }[] = [
    { key: 'cyber', label: '赛博朋克 (Cyber)', icon: <ThunderboltFilled /> },
    { key: 'glass', label: '玻璃态 (Glass)', icon: <ExperimentFilled /> },
    { key: 'neumorph', label: '新拟态 (Neumorph)', icon: <BlockOutlined /> },
    { key: 'light', label: '简约白 (Light)', icon: <SunOutlined /> },
  ];

  const items = [
    {
      key: 'auto',
      label: (
        <Space>
          <SettingOutlined spin={isAutoMode} />
          <span>自动适配路由</span>
          {isAutoMode && <CheckOutlined style={{ color: '#52c41a' }} />}
        </Space>
      ),
      onClick: () => setAutoMode(!isAutoMode),
    },
    {
      type: 'divider',
    },
    ...themes.map(t => ({
      key: t.key,
      label: (
        <Space>
          {t.icon}
          <span>{t.label}</span>
          {currentTheme === t.key && !isAutoMode && <CheckOutlined style={{ color: '#1890ff' }} />}
        </Space>
      ),
      onClick: () => setTheme(t.key),
    })),
  ];

  const getCurrentIcon = () => {
    const theme = themes.find(t => t.key === currentTheme);
    return theme ? theme.icon : <BgColorsOutlined />;
  };

  return (
    <div className="theme-switch-container">
      <Dropdown menu={{ items: items as any }} placement="bottomRight" arrow>
        <Tooltip title={isAutoMode ? "当前：自动适配" : "点击切换主题"}>
          <Button 
            shape="circle" 
            icon={getCurrentIcon()} 
            className={`theme-switch-btn ${isAutoMode ? 'auto-mode' : ''}`}
            style={{ 
              border: 'none', 
              boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
              background: currentTheme === 'dark' ? 'rgba(255,255,255,0.1)' : '#fff'
            }}
          />
        </Tooltip>
      </Dropdown>
      <span className="theme-switch-label" style={{ marginLeft: 8, fontSize: 12, opacity: 0.8 }}>
        {themes.find(t => t.key === currentTheme)?.label.split(' ')[0]}
      </span>
    </div>
  );
};

export default ThemeSwitch;
